import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";
import {CreateGeofence, UpdateGeofence} from "../../types/api/guide/geofence.types";

const pagedQuery = (page: number, pageSize: number, name?: string) => {
    const params: Record<string, string | number> = { page, pageSize };
    if (name != null && name.trim() !== "") params.name = name.trim();
    return { params };
};

export const geofenceService = {
    getAll: () =>
        apiCall.get(apiUrls.guide.geofence.getAll),

    getPaged: (page: number, pageSize: number, name?: string) =>
        apiCall.get(apiUrls.guide.geofence.getPaged, pagedQuery(page, pageSize, name)),

    create: (geofence: CreateGeofence) =>
        apiCall.post(apiUrls.guide.geofence.create, geofence),

    update: (id: string, geofence: UpdateGeofence) =>
        apiCall.put(apiUrls.guide.geofence.update(id), geofence),

    delete: (id: string) =>
        apiCall.delete(apiUrls.guide.geofence.delete(id)),

    getById: (id: string) =>
        apiCall.get(apiUrls.guide.geofence.getById(id))
}